/** A non-null, non-array object. This deliberately does not require Object.prototype. */
export const isRecord = value => value !== null && typeof value === 'object' && !Array.isArray(value);

/** The same guard for optional property traversal. */
export const record = value => isRecord(value) ? value : undefined;
